import script from "./OrdersBulkUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersBulkUploader.vue?vue&type=script&setup=true&lang=js"

import "./OrdersBulkUploader.vue?vue&type=style&index=0&id=5c155f38&lang=css"

const __exports__ = script;

export default __exports__